import React, { FunctionComponent, useState } from "react";
import { Button } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";

type DiplomProps = {
    diplomas: string[];
    isPremium: boolean;
};

export const Diplom: FunctionComponent<DiplomProps> = ({
    diplomas,
    isPremium
}) => {


    const classes = useStyles();
    const { t } = useTranslation();

    const [brokenImagesCount, setBrokenImagesCount] = useState(0);
    const totalImages = diplomas.length;
    if (brokenImagesCount === totalImages) {
        return null;
    }

    return (
        <div className={classes.container}>
            {diplomas.map(url => <DiplomaImg key={url} url={url} onError={() => setBrokenImagesCount((prev) => prev + 1)} />)}
            {!isPremium && <Button className={classes.button} variant="contained" color="primary" href="https://shop.s10.run/products/s10challenge-diploma?utm_source=s10&utm_medium=protocol&utm_campaign=diploma">{t('buyDiplom')}</Button>}
        </div>
    );
}

interface DiplomaImgProps {
    url: string;
    onError: () => void;
}

const DiplomaImg: FunctionComponent<DiplomaImgProps> = ({
    url,
    onError,
}) => {
    const classes = useStyles();

    return <img 
        className={classes.img} 
        src={url} 
        onError={() => {
            onError();
        }}
    />
}

const useStyles = makeStyles({
    container: {
        margin: "1rem 0",
        padding: "1rem",
        boxSizing: "border-box",
        width: "100%",
        display: "flex",
        flexDirection: "column"
    },
    img: {
        maxWidth: "100%",
        '&:not(:last-child)': {
            marginBottom: "1rem"
        }
    },
    button: {
        marginTop: "1rem"
    }
})